import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-edit-modal',
  templateUrl: './add-edit-modal.component.html',
  styleUrls: ['./add-edit-modal.component.scss']
})
export class AddEditModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
